import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = ["onContextmenu", "onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "pa-0" }

import ClientsTariffProgressbar from '@/components/Client/ClientsTariffProgressbar.vue';
import DataTableHeader from '@/components/chunks/DataTableHeader.vue';
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import SearchInput from '@/components/ui/SearchInput.vue';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';
import { useClientStore } from '@/store/client';
import { Client } from '@/types';
import { SortItem } from '@/types/SortItem';
import { DEFAULT_PAGINATION_PAGE, PAGINATION_TABLES_NAMES, PROVIDE_KEYS, DATE_FORMAT, LANG } from '@/utils/constants';
import { getClientStatusText } from '@/utils/functions';
import { inject, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import moment from 'moment';
import localStorage from '@/utils/localStorage';
import AppBottomBar from '@/components/AppBottomBar.vue';
import ClientService from '@/backend/service/ClientService';
import ClientStatus from '@/types/ClientStatus';
import CustomProgressCircular from '@/components/ui/CustomProgressCircular.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientsTable',
  setup(__props) {

const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);
const { t } = useI18n();
let clientStore = useClientStore();
const router = useRouter();
const { handleUpdatePageSize, getTablePageSize, handleUpdateOrder, getTableOrder, getTablePage, handleUpdatePage } =
  useTablePaginationMixin();
let deleteCandidate = {} as Client;
const pageSize = ref(getTablePageSize(PAGINATION_TABLES_NAMES.CLIENTS));
const currentPage = ref(DEFAULT_PAGINATION_PAGE);
const savedOrder: SortItem = getTableOrder(PAGINATION_TABLES_NAMES.CLIENTS);
const startOrder = savedOrder && Object.keys(savedOrder).length > 0 ? savedOrder : { key: 'createdAt', order: 'desc' };
const currentOrder = ref([startOrder] as SortItem[]);

const clientDeleteConfirm = ref();
const contextMenu = ref(false);
const attachToRow = ref<[x: number, y: number]>([0, 0]);

const selectedClientsIds = ref<number[]>([]);
const showSelectCol = ref<boolean>(false);
const lastSelectedClient = ref({} as Client);
const sendAccessInProcess = ref(false);
const deleteGroupInProcess = ref(false);

const headers: any = [
  { title: 'TextField.FirstName', key: 'firstName' },
  { title: 'TextField.LastName', key: 'lastName' },
  { title: 'TextField.Email', key: 'email' },
  { title: 'TextField.TeleguardId', key: 'teleguardId' },
  { title: 'TextField.Status', key: 'status' },
  { title: 'TextField.CreatedAt', key: 'createdAt' },
  { title: '', key: 'actions', sortable: false, width:20 }
];
let search = ref('');

onMounted(() => {
  watch(
    () => selectedClientsIds.value,
    () => {
      showSelectCol.value = selectedClientsIds.value.length > 0;
    },
    {
      deep: true
    }
  );
});

clientStore.fetchClients().finally(() => (currentPage.value = getTablePage(PAGINATION_TABLES_NAMES.CLIENTS)));

function onUpdatePage(value: number) {
  currentPage.value = value;
  handleUpdatePage(PAGINATION_TABLES_NAMES.CLIENTS, value);
}

function onUpdateItemsPerPage(value: number) {
  pageSize.value = value;
  handleUpdatePageSize(PAGINATION_TABLES_NAMES.CLIENTS, value);
}

function onUpdateSortBy(options: SortItem[]) {
  const value = options[0];
  handleUpdateOrder(PAGINATION_TABLES_NAMES.CLIENTS, value);
}

function handleClickRow(ev: MouseEvent, row: Client) {
  if (showSelectCol.value) {
    return false;
  }

  if (!row.inProcess) {
    router.push({ name: 'UpdateClient', params: { clientId: row.id } });
  }
}

function deleteSelectedRow() {
  clientDeleteConfirm.value.open();
  deleteCandidate = lastSelectedClient.value;
}

function onRightClickTableRow(ev: MouseEvent, data: Client) {
  ev.preventDefault();
  attachToRow.value = [ev.clientX, ev.clientY];
  contextMenu.value = true;
  lastSelectedClient.value = data;
}

function onUpdateVisibilityContextMenu(value: boolean) {
  contextMenu.value = value;
  lastSelectedClient.value = {};
}

function onSelectRow() {
  const lastSelectedClientId = lastSelectedClient.value.id as number;
  selectedClientsIds.value.push(lastSelectedClientId);
}

function clickOkConfirm() {
  clientStore
    .deleteClient(deleteCandidate.id!)
    .then(() => {
      showSnackbar('ResponseMessage.Client.Delete.Success');
    })
    .catch(() => {
      showSnackbar('ResponseMessage.Client.Delete.Error');
    });
}
function onCloseConfirm() {
  deleteCandidate = {} as Client;
}

function clearSelectedIds() {
  selectedClientsIds.value = [];
  lastSelectedClient.value = {};
}

function deleteSelectedIds() {
  deleteGroupInProcess.value = true;
  let requests:Promise<string>[] = [];
  selectedClientsIds.value.map((clientId) => {
    const resp = clientStore.deleteClient(clientId);
    requests.push(resp);
  });
  Promise.allSettled(requests)
    .then((responses) => {
      const hasError = responses.filter(response => response.status == 'rejected').length > 0;
      if(hasError){
        showSnackbar('ResponseMessage.Client.Delete.ManyError');
      }else{
        showSnackbar('ResponseMessage.Client.Delete.ManySuccess');
      }
    })
    .finally(()=>{
      deleteGroupInProcess.value = false;
      clearSelectedIds();
    })
}

function onSendAccessClientQR() {
  const locale = localStorage.get(LANG);
  ClientService.sendAccessToContact(lastSelectedClient.value.id as number, locale)
    .then(
      () => {
        showSnackbar('ResponseMessage.Client.SendAccess.Success');
      },
      () => {
        showSnackbar('ResponseMessage.Client.SendAccess.Error');
      }
    );
}

function onSendAccessGroupClientQR() {
  sendAccessInProcess.value = true;
  const locale = localStorage.get(LANG);
  let accessRequests:Promise<string>[] = []
  selectedClientsIds.value.map((clientId) =>{
    const resp = ClientService.sendAccessToContact(clientId as number, locale);
    accessRequests.push(resp);
  });

  if(accessRequests.length > 0){
    Promise.allSettled(accessRequests).then(
      (responses) => {
        const hasError = responses.filter(response => response.status == 'rejected').length > 0;
        if(hasError){
          showSnackbar('ResponseMessage.Client.SendAccess.ManyError');        
        }else{
          showSnackbar('ResponseMessage.Client.SendAccess.ManySuccess');
        }
      }
    ).finally(()=>sendAccessInProcess.value = false);
  }  
}

function needSendQRByStatus(clientStatus:ClientStatus){
  return [ClientStatus.VERIFIED, ClientStatus.REVERIFIED, ClientStatus.CREATED, ClientStatus.RECREATED].includes(clientStatus);
}

function isSelectedRow(clientId:number){
  return selectedClientsIds.value.includes(clientId);
}

return (_ctx: any,_cache: any) => {
  const _component_VCheckboxBtn = _resolveComponent("VCheckboxBtn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SearchInput, {
          modelValue: _unref(search),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
          class: "mt-4 mb-2"
        }, null, 8, ["modelValue"]),
        _createVNode(ClientsTariffProgressbar, { class: "clients-progressbar mb-5" }),
        _createVNode(_component_v_data_table, {
          modelValue: selectedClientsIds.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedClientsIds).value = $event)),
          "sort-by": currentOrder.value,
          "onUpdate:sortBy": [
            _cache[3] || (_cache[3] = ($event: any) => ((currentOrder).value = $event)),
            onUpdateSortBy
          ],
          page: currentPage.value,
          "onUpdate:page": [
            _cache[4] || (_cache[4] = ($event: any) => ((currentPage).value = $event)),
            onUpdatePage
          ],
          headers: headers,
          items: _unref(clientStore).getClients,
          search: _unref(search),
          "items-per-page": pageSize.value,
          "show-select": showSelectCol.value,
          "onClick:row": handleClickRow,
          "onUpdate:itemsPerPage": onUpdateItemsPerPage
        }, {
          headers: _withCtx(({ columns, isSorted, getSortIcon, toggleSort }) => [
            _createVNode(DataTableHeader, {
              columns: columns,
              "is-sorted": isSorted,
              "get-sort-icon": getSortIcon,
              "toggle-sort": toggleSort
            }, null, 8, ["columns", "is-sorted", "get-sort-icon", "toggle-sort"])
          ]),
          item: _withCtx(({ item }) => [
            _createElementVNode("tr", {
              class: _normalizeClass(["client-table__row", {'row--selected':isSelectedRow(item.id!)}]),
              onContextmenu: ($event: any) => (onRightClickTableRow($event, item)),
              onClick: ($event: any) => (handleClickRow($event, item))
            }, [
              (showSelectCol.value)
                ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                    _createVNode(_component_VCheckboxBtn, {
                      modelValue: selectedClientsIds.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedClientsIds).value = $event)),
                      value: item.id,
                      color: "primary",
                      "hide-details": ""
                    }, null, 8, ["modelValue", "value"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, _toDisplayString(item.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(item.lastName), 1),
              _createElementVNode("td", null, _toDisplayString(item.email), 1),
              _createElementVNode("td", null, _toDisplayString(item.teleguardId), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(t)(_unref(getClientStatusText)(item.status!))), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(moment)(item.createdAt).format(_unref(DATE_FORMAT))), 1),
              _createElementVNode("td", _hoisted_4, [
                _withDirectives(_createVNode(CustomProgressCircular, { size: 30 }, null, 512), [
                  [_vShow, (item as Client).inProcess]
                ])
              ])
            ], 42, _hoisted_2)
          ]),
          _: 1
        }, 8, ["modelValue", "sort-by", "page", "items", "search", "items-per-page", "show-select"]),
        _createVNode(_component_v_menu, {
          target: attachToRow.value,
          "model-value": contextMenu.value,
          transition: "slide-y-transition",
          "onUpdate:modelValue": onUpdateVisibilityContextMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              density: "compact",
              class: "context-menu-list py-0"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_list_item, { onClick: onSelectRow }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "primary",
                      icon: "mdi-checkbox-marked-outline"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Label.Select')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_ripple]
                ]),
                _createVNode(_component_v_divider),
                _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                  disabled: !needSendQRByStatus(lastSelectedClient.value.status!),
                  onClick: onSendAccessClientQR
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "primary",
                      icon: "mdi-email-arrow-right-outline"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Label.SendQRCode')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])), [
                  [_directive_ripple]
                ]),
                _createVNode(_component_v_divider),
                _withDirectives((_openBlock(), _createBlock(_component_v_list_item, { onClick: deleteSelectedRow }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "error",
                      icon: "mdi-delete-empty-outline"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Button.Delete')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_ripple]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["target", "model-value"]),
        _createVNode(ConfirmDialog, {
          ref_key: "clientDeleteConfirm",
          ref: clientDeleteConfirm,
          onClickOk: clickOkConfirm,
          onClose: onCloseConfirm
        }, null, 512)
      ]),
      (selectedClientsIds.value.length > 0)
        ? (_openBlock(), _createBlock(AppBottomBar, {
            key: 0,
            class: "justify-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mr-2 text-none",
                color: "error",
                variant: "outlined",
                "prepend-icon": "mdi-delete-empty-outline",
                disabled: deleteGroupInProcess.value,
                loading: deleteGroupInProcess.value,
                onClick: deleteSelectedIds
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Button.Delete')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_component_v_btn, {
                class: "mr-2 text-none",
                color: "primary",
                variant: "outlined",
                "prepend-icon": "mdi-email-arrow-right-outline",
                disabled: sendAccessInProcess.value,
                loading: sendAccessInProcess.value,
                onClick: onSendAccessGroupClientQR
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Label.SendQRCode')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_component_v_btn, {
                class: "text-none",
                color: "primary",
                variant: "outlined",
                onClick: clearSelectedIds
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Button.Cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})